import { Box, Chip as ChipBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  align-items: center;
`;

export const Chip = styled(ChipBase)``;
